import { useEffect } from "react";

import { useRecoilState } from "recoil";
import { useRefract } from "refract-rxjs";

import { PaginationAtomsKeys } from "../../shared/state";
import { debouncedSearchAperture } from "../effects";
import { searchInputAtom } from "../state";

export const useLensesDebouncedSearch = (
    searchName: string,
    setSearch: (search: string) => void,
    paginationAtomsKey: PaginationAtomsKeys = PaginationAtomsKeys.LensesList,
): {
    lensSearchText: string;
    setLensSearchText: (lensSearchText: string) => void;
} => {
    const [lensSearchText, setLensSearchText] = useRecoilState(searchInputAtom(paginationAtomsKey));

    const debouncedSearch = useRefract<{ lensSearchText: string }, string>(debouncedSearchAperture, { lensSearchText });

    useEffect(() => {
        if (debouncedSearch !== searchName) {
            setSearch(debouncedSearch);
        }
    }, [debouncedSearch, searchName, setSearch]);

    return { lensSearchText, setLensSearchText };
};
